<template>
    <ProfileWrap/>
</template>

<script>
import ProfileWrap   from '@/components/view_blocks/Profile/profile_wrap.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    ProfileWrap,
  },
};
</script>

